const insSyncConfig = [{
  desc: '保单设置——同步设置查询所有同步的工号',
  options: {
    url: '/insSyncConfig/query',
    method: 'get'
  }
}, {
  desc: '同步设置 保存同步工号数据',
  options: {
    url: '/insSyncConfig/save',
    method: 'post'
  }
}, {
  desc: '同步设置 新增同步工号时',
  options: {
    url: '/insSyncConfig/verifyAccount',
    method: 'post'
  }
}]
export default insSyncConfig



// WEBPACK FOOTER //
// ./src/api/insSyncConfig.js